module.exports = __webpack_public_path__ + "static/media/29COICT1.6ea4a604.jpg";